var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProperty1HomeHealth24DpE8EaedFill0Wght400Grad0Opsz24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 17H13.5V14.5H16V11.5H13.5V9H10.5V11.5H8V14.5H10.5V17ZM4 21V9L12 3L20 9V21H4ZM6 19H18V10L12 5.5L6 10V19Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProperty1HomeHealth24DpE8EaedFill0Wght400Grad0Opsz24);
export default __webpack_public_path__ + "static/media/Property 1=home_health_24dp_E8EAED_FILL0_wght400_GRAD0_opsz24.e4b63847e1589d07422fdb263b53f1f8.svg";
export { ForwardRef as ReactComponent };